import { render, staticRenderFns } from "./SalonChipStack.vue?vue&type=template&id=12ce7788&scoped=true"
import script from "./SalonChipStack.vue?vue&type=script&lang=js"
export * from "./SalonChipStack.vue?vue&type=script&lang=js"
import style0 from "./SalonChipStack.vue?vue&type=style&index=0&id=12ce7788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce7788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VIcon,VImg})
